import { render, staticRenderFns } from "./PlanBox.vue?vue&type=template&id=d01dacfe&scoped=true&"
import script from "./PlanBox.vue?vue&type=script&lang=js&"
export * from "./PlanBox.vue?vue&type=script&lang=js&"
import style0 from "./css2.css?vue&type=style&index=0&id=d01dacfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01dacfe",
  null
  
)

export default component.exports